var _mask, _path, _path2, _g, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicenseExam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_519_46645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 34,
    height: 38
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_519_46645",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4375 3.4375H36.4375V14.2656L23.7422 26.9609L25.793 29.0117H18.8359V40.5625H3.4375V3.4375Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4375 3.4375H36.4375V14.2656L23.7422 26.9609L25.793 29.0117H18.8359V40.5625H3.4375V3.4375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4375 3.4375H37.8125V2.0625H36.4375V3.4375ZM3.4375 3.4375V2.0625H2.0625V3.4375H3.4375ZM36.4375 14.2656L37.4098 15.2379L37.8125 14.8352V14.2656H36.4375ZM23.7422 26.9609L22.7699 25.9887L21.7976 26.9609L22.7699 27.9332L23.7422 26.9609ZM25.793 29.0117V30.3867H29.1125L26.7652 28.0394L25.793 29.0117ZM18.8359 29.0117V27.6367H17.4609V29.0117H18.8359ZM18.8359 40.5625V41.9375H20.2109V40.5625H18.8359ZM3.4375 40.5625H2.0625V41.9375H3.4375V40.5625ZM36.4375 2.0625H3.4375V4.8125H36.4375V2.0625ZM37.8125 14.2656V3.4375H35.0625V14.2656H37.8125ZM24.7145 27.9332L37.4098 15.2379L35.4652 13.2934L22.7699 25.9887L24.7145 27.9332ZM26.7652 28.0394L24.7145 25.9887L22.7699 27.9332L24.8207 29.984L26.7652 28.0394ZM18.8359 30.3867H25.793V27.6367H18.8359V30.3867ZM20.2109 40.5625V29.0117H17.4609V40.5625H20.2109ZM3.4375 41.9375H18.8359V39.1875H3.4375V41.9375ZM2.0625 3.4375V40.5625H4.8125V3.4375H2.0625Z",
    fill: "white",
    mask: "url(#path-1-inside-1_519_46645)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_519_46645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 6.1875H35.0625V32.3125C35.0625 35.3501 32.6001 37.8125 29.5625 37.8125H11.6875C8.64993 37.8125 6.1875 35.3501 6.1875 32.3125V6.1875Z",
    stroke: "#333333",
    strokeWidth: 2.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.0625,
    y: 11.6875,
    width: 15.125,
    height: 2.75,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.0625,
    y: 18.5625,
    width: 9.625,
    height: 2.75,
    fill: "#333333"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.625,
    cy: 31.625,
    r: 8.9375,
    fill: "#E8192C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 24.75V30.25H37.125",
    stroke: "white",
    strokeWidth: 2.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseExam);
export default __webpack_public_path__ + "static/media/license-exam.5c8b63f1b6fab073f45a8a3ddac89d35.svg";
export { ForwardRef as ReactComponent };